import { render, staticRenderFns } from "./MaterialRow.vue?vue&type=template&id=3f6d7ab8&scoped=true"
import script from "./MaterialRow.vue?vue&type=script&lang=js"
export * from "./MaterialRow.vue?vue&type=script&lang=js"
import style0 from "./MaterialRow.vue?vue&type=style&index=0&id=3f6d7ab8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d7ab8",
  null
  
)

export default component.exports